import { AutoMap } from "@automapper/classes";
import { Model } from "../base/base.model";

export class Token extends Model {
    @AutoMap()
  public accessToken!: string;
}
